import styled from 'styled-components';
import { Modal } from 'react-bootstrap';


export const ModalConfirmarComponent = styled(Modal).attrs({
    className: ``
})`


`